export default __webpack_public_path__ + "static/media/object--street-light.99b39470.png";